<template>
    <section class="bg-black">
      <div class="max-w-5xl py-8 mx-auto md:py-20">
        <div class="max-w-3xl px-4 mx-auto sm-max:text-center">
          <!-- Title -->
          <div class="text-xl text-center text-white lg:text-left sm:text-2xl xl:text-3xl font-ww-bold" v-html="title"></div>
  
          <!-- Description -->
          <div class="mt-6 text-center text-white sm:text-lg xl:text-xl font-ww-light lg:text-left" v-html="description"></div>
  
          <!-- Remember Section -->
          <div class="grid grid-cols-12 mt-6 gap-x-4 lg:gap-x-12 gap-y-8">
            <div
              v-for="(item, index) in rememberItems"
              :key="index"
              class="flex flex-col col-span-12 sm:col-span-6 lg:col-span-3 gap-y-3"
            >
              <nuxt-img
                :src="item.imgSrc"
                :alt="item.alt"
                sizes="xs:46px sm:46px md:46px lg:146px xl:46px 2xl:46px"
                loading="lazy"
                fetchpriority="high"
                format="webp"
                width="46"
                height="46"
                class="w-10 mx-auto lg:mx-0 md:w-12"
              />
              <div
                class="text-base lg:text-left text-center text-white font-ww-light xl:text-lg !leading-6"
              >
                {{ item.text }}
              </div>
            </div>
          </div>
  
          <!-- Call to Action Button -->
          <button
           @click="scrollTo(buttonLink)"
            class="bg-lifeboost-red uppercase text-lg lg:text-xl font-ww-bold text-white w-full py-2 lg:py-2.5 mt-8 rounded-3xl"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  const props = defineProps({
    title: {
      type: String,
      default: "Don’t Wait Until Prices Surge...",
    },
    description: {
      type: String,
      default: `Lock in your Anti-Inflation Shield protection now and join thousands of smart coffee lovers who are already saving while enjoying the world's cleanest, healthiest coffee.<br><br>Remember :`,
    },
    rememberItems: {
      type: Array,
      default: () => [
        {
          imgSrc: "/assets/images/remember-1.png",
          alt: "Coffee prices expected to double by 2026",
          text: "Coffee prices expected to double by 2026",
        },
        {
          imgSrc: "/assets/images/remember-2.png",
          alt: "Limited subscriptions available at current rates",
          text: "Limited subscriptions available at current rates",
        },
        {
          imgSrc: "/assets/images/remember-3.png",
          alt: "Price protection only guaranteed for new subscribers",
          text: "Price protection only guaranteed for new subscribers",
        },
        {
          imgSrc: "/assets/images/remember-4.png",
          alt: "Next price increase coming [Date]",
          text: "Next price increase coming [Date]",
        },
      ],
    },
    buttonText: {
      type: String,
      default: "Lock In Your Price NOW",
    },
    buttonLink: {
      type: String,
      default: "#",
    },
  });
  
  defineBuilderComponent({
    friendlyName: "FeatureWithIconsAndCTA",
    inputs: [
      {
        name: "title",
        type: "richText",
        friendlyName: "Section Title",
        defaultValue: "Don’t Wait Until Prices Surge...",
      },
      {
        name: "description",
        type: "richText",
        friendlyName: "Section Description",
        defaultValue:
          `Lock in your Anti-Inflation Shield protection now and join thousands of smart coffee lovers who are already saving while enjoying the world's cleanest, healthiest coffee.<br><br>Remember :`,
      },
      {
        name: "rememberItems",
        type: "list",
        friendlyName: "Remember Items",
        subFields: [
          {
            name: "imgSrc",
            type: "file",
            friendlyName: "Item Image Source",
            allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
          },
          {
            name: "alt",
            type: "text",
            friendlyName: "Item Image Alt Text",
          },
          {
            name: "text",
            type: "text",
            friendlyName: "Item Text",
          },
        ],
        defaultValue: [
          {
            imgSrc: "/assets/images/remember-1.png",
            alt: "Coffee prices expected to double by 2026",
            text: "Coffee prices expected to double by 2026",
          },
          {
            imgSrc: "/assets/images/remember-2.png",
            alt: "Limited subscriptions available at current rates",
            text: "Limited subscriptions available at current rates",
          },
          {
            imgSrc: "/assets/images/remember-3.png",
            alt: "Price protection only guaranteed for new subscribers",
            text: "Price protection only guaranteed for new subscribers",
          },
          {
            imgSrc: "/assets/images/remember-4.png",
            alt: "Next price increase coming [Date]",
            text: "Next price increase coming [Date]",
          },
        ],
      },
      {
        name: "buttonText",
        type: "text",
        friendlyName: "Button Text",
        defaultValue: "Lock In Your Price NOW",
      },
      {
        name: "buttonLink",
        type: "string",
        friendlyName: "Button Link",
        defaultValue: "#",
      },
    ],
  });
  </script>
  